module.exports = __webpack_public_path__ + "img/soft-drink.ea77c84c.png";